
import AccountTaxAddress from '~/pages/_lang/account/billing/index.vue'
export default AccountTaxAddress
